(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-landing"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   Lógica del selector "Arma tu arsenal".
   Lee los datos reales desde window.ARSENAL[sectionId]
   (generados con Liquid arriba). NO usa localStorage.
   El descuento mostrado es ESTIMADO; el cobro real lo aplica
   el Automatic Discount de Shopify en el carrito/checkout.
   ============================================================ */
(function () {
  function money(n) { return '$' + Math.round(n).toLocaleString('es-MX') + ' MXN'; }

  function initArsenal(root) {
    var sectionId = root.id.replace('mensshop-arsenal-', '');
    var data = (window.ARSENAL || {})[sectionId];
    if (!data) return;

    var CATALOG = data.catalog, PROMO = data.promo, L = data.labels;
    var shell = root.querySelector('[data-arsenal]');
    if (!shell) return;

    var current = 'A';
    var sel = {}; // ids elegidos por slot

    var elSlots = shell.querySelector('[data-slots]');
    var elSummary = shell.querySelector('[data-summary]');
    var elBadge = shell.querySelector('[data-promo-badge]');
    var elSub = shell.querySelector('[data-promo-sub]');
    var elSaveBig = shell.querySelector('[data-save-big]');
    var elSaveSub = shell.querySelector('[data-save-sub]');
    var elAddBtn = shell.querySelector('[data-add-btn]');
    var elAddMsg = shell.querySelector('[data-add-msg]');
    var toggleBtns = shell.querySelectorAll('[data-set-promo]');

    function hasProducts(p) { return CATALOG[p] && CATALOG[p].length > 0; }

    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function pctOff(p) {
      return (p && p.compare && p.compare > p.price) ? Math.round((1 - p.price / p.compare) * 100) : 0;
    }
    function filterList(list, empty, q, minPct) {
      minPct = minPct || 0;
      var shown = 0;
      list.querySelectorAll('.ms-combo-opt').forEach(function (li) {
        var pct = parseInt(li.getAttribute('data-pct') || '0', 10);
        var match = (!q || li.getAttribute('data-search').indexOf(q) >= 0) && pct >= minPct;
        li.style.display = match ? '' : 'none';
        if (match) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    }
    function closeAllCombos(root) {
      root.querySelectorAll('.ms-combo-panel').forEach(function (p) { p.hidden = true; });
      root.querySelectorAll('.ms-combo-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    document.addEventListener('click', function () { closeAllCombos(root); });

    function setPromo(p) {
      if (!hasProducts(p)) return;
      current = p;
      toggleBtns.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-set-promo') === p); });
      elBadge.textContent = PROMO[p].badge;
      elSub.textContent = PROMO[p].sub;
      buildSlots();
    }

    function buildSlots() {
      elSlots.innerHTML = '';
      var cfg = PROMO[current], cat = CATALOG[current];
      if (!cat || !cat.length) {
        elSlots.innerHTML = '<p style="color:var(--muted);text-align:center;padding:10px">Conecta productos a esta promo en el Theme Editor.</p>';
        elSummary.innerHTML = ''; elSaveBig.textContent = money(0);
        return;
      }
      for (var i = 0; i < cfg.slots; i++) {
        var isFree = (i >= cfg.pay); // último(s) slot(s) gratis (visual)
        var key = current + '_' + i;
        if (sel[key] === undefined) sel[key] = cat[i % cat.length].id;

        var div = document.createElement('div');
        div.className = 'ms-slot' + (isFree ? ' free' : '');

        var chosen = cat.filter(function (x) { return String(x.id) === String(sel[key]); })[0] || cat[0];
        var tagTxt = isFree ? L.tagFree : money(chosen.price);
        var slotLabel = isFree ? L.slotFree : (L.slotPaid + ' ' + (i + 1));
        var chosenPct = pctOff(chosen);
        var offBadge = (!isFree && chosenPct > 0) ? '<span class="ms-slot-off">-' + chosenPct + '%</span>' : '';
        var thumbInner = (chosen.img ? '<img src="' + esc(chosen.img) + '" alt="" loading="lazy">' : '🧴') + offBadge;

        // opciones del dropdown con buscador + % de ahorro
        var optsHtml = cat.map(function (prod) {
          var lbl = prod.name + (prod.note ? ' · ' + prod.note : '');
          var search = (prod.name + ' ' + (prod.note || '')).toLowerCase();
          var selCls = String(sel[key]) === String(prod.id) ? ' is-sel' : '';
          var pct = pctOff(prod);
          return '<li class="ms-combo-opt' + selCls + '" data-id="' + esc(prod.id) + '" data-pct="' + pct + '" data-search="' + esc(search) + '">' +
                   (prod.img ? '<img src="' + esc(prod.img) + '" alt="" loading="lazy">' : '<span class="ms-combo-opt-ph">🧴</span>') +
                   '<span class="ms-combo-opt-name">' + esc(lbl) + '</span>' +
                   (pct > 0 ? '<span class="ms-combo-opt-off">-' + pct + '%</span>' : '') +
                   '<span class="ms-combo-opt-price">' + esc(money(prod.price)) + '</span>' +
                 '</li>';
        }).join('');
        var chosenLabel = chosen.name + (chosen.note ? ' · ' + chosen.note : '');

        // chips de filtro por ahorro (solo en promos modo "compare")
        var filtersHtml = (cfg.mode === 'compare')
          ? '<div class="ms-combo-filters">' +
              '<button type="button" data-minpct="0" class="on">Todos</button>' +
              '<button type="button" data-minpct="30">30%+</button>' +
              '<button type="button" data-minpct="40">40%+</button>' +
              '<button type="button" data-minpct="50">50%+</button>' +
            '</div>'
          : '';

        div.innerHTML =
          '<div class="thumb">' + thumbInner + '</div>' +
          '<div class="slot-main">' +
            '<div class="slot-label">' + slotLabel + '</div>' +
            '<div class="ms-combo">' +
              '<button type="button" class="ms-combo-btn" aria-haspopup="listbox" aria-expanded="false">' +
                '<span class="ms-combo-current">' + esc(chosenLabel) + '</span>' +
                '<span class="ms-combo-caret">▾</span>' +
              '</button>' +
              '<div class="ms-combo-panel" hidden>' +
                '<input type="text" class="ms-combo-search" placeholder="' + esc(L.searchPlaceholder || 'Buscar perfume…') + '" autocomplete="off">' +
                filtersHtml +
                '<ul class="ms-combo-list">' + optsHtml + '</ul>' +
                '<div class="ms-combo-empty" hidden>Sin resultados</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="tag ' + (isFree ? 'tag-free' : 'tag-pay') + '">' + tagTxt + '</div>';

        (function (idx, slotEl) {
          var combo = slotEl.querySelector('.ms-combo');
          var btn = combo.querySelector('.ms-combo-btn');
          var panel = combo.querySelector('.ms-combo-panel');
          var search = combo.querySelector('.ms-combo-search');
          var list = combo.querySelector('.ms-combo-list');
          var empty = combo.querySelector('.ms-combo-empty');
          var filterBtns = combo.querySelectorAll('.ms-combo-filters button');
          var minPct = 0;

          filterBtns.forEach(function (fb) {
            fb.addEventListener('click', function (e) {
              e.stopPropagation();
              minPct = parseInt(fb.getAttribute('data-minpct'), 10) || 0;
              filterBtns.forEach(function (x) { x.classList.toggle('on', x === fb); });
              filterList(list, empty, search.value.toLowerCase(), minPct);
            });
          });

          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            var wasOpen = !panel.hidden;
            closeAllCombos(root);
            if (!wasOpen) {
              panel.hidden = false;
              btn.setAttribute('aria-expanded', 'true');
              search.value = '';
              filterList(list, empty, '', minPct);
              // En móvil NO enfocamos el buscador para no abrir el teclado automáticamente.
              var isTouch = window.matchMedia && window.matchMedia('(max-width: 860px)').matches;
              if (!isTouch) search.focus();
              panel.scrollTop = 0;
            }
          });
          search.addEventListener('click', function (e) { e.stopPropagation(); });
          search.addEventListener('input', function () { filterList(list, empty, search.value.toLowerCase(), minPct); });
          list.addEventListener('click', function (e) {
            var li = e.target.closest('.ms-combo-opt');
            if (!li) return;
            sel[current + '_' + idx] = li.getAttribute('data-id');
            buildSlots();
          });
        })(i, div);

        elSlots.appendChild(div);
      }
      render();
    }

    function render() {
      var cfg = PROMO[current], cat = CATALOG[current];
      var prices = [], compares = [];
      for (var i = 0; i < cfg.slots; i++) {
        var p = cat.filter(function (x) { return String(x.id) === String(sel[current + '_' + i]); })[0];
        prices.push(p ? p.price : 0);
        compares.push(p ? (p.compare || p.price) : 0);
      }
      var subtotal = prices.reduce(function (a, b) { return a + b; }, 0);
      var realValue, discount, total, discCount, discLabel;

      if (cfg.mode === 'compare') {
        // Promo "compra N y aprovecha el ahorro" -> ahorro REAL vs precio tachado (compare_at_price)
        realValue = compares.reduce(function (a, b) { return a + b; }, 0);
        total = subtotal;
        discount = realValue - subtotal;
        discCount = cfg.slots;
      } else {
        // Promo "el/los más barato(s) gratis" (4×3, 3×2, etc.)
        realValue = subtotal;
        var sorted = prices.slice().sort(function (a, b) { return a - b; });
        var freeCount = cfg.slots - cfg.pay;
        discount = 0;
        for (var j = 0; j < freeCount; j++) discount += (sorted[j] || 0);
        total = subtotal - discount;
        discCount = freeCount;
      }

      var discLabel = (cfg.mode === 'compare')
        ? (L.discount + ' (' + (realValue > 0 ? Math.round(discount / realValue * 100) : 0) + '% OFF)')
        : (L.discount + ' ' + cfg.off + ' (' + discCount + ')');

      elSummary.innerHTML =
        '<div class="ms-srow"><span>' + L.realValue + ' (' + cfg.slots + ')</span><span>' + money(realValue) + '</span></div>' +
        '<div class="ms-srow disc"><span>' + discLabel + '</span><span>-' + money(discount) + '</span></div>' +
        '<div class="ms-srow total"><span>' + L.totalLabel + '</span><span class="amt">' + money(total) + '</span></div>';

      elSaveBig.textContent = money(discount);
      elSaveSub.textContent = L.saveSub;
      elAddBtn.textContent = L.addText.replace('{total}', money(total));
    }

    function addToCart(e) {
      e.preventDefault();
      var cfg = PROMO[current];
      var items = [];
      for (var i = 0; i < cfg.slots; i++) {
        var id = sel[current + '_' + i];
        if (id) items.push({ id: Number(id), quantity: 1 });
      }
      if (!items.length) return;

      elAddMsg.textContent = '';
      var original = elAddBtn.textContent;
      elAddBtn.textContent = L.adding;
      elAddBtn.style.pointerEvents = 'none';

      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      // ¿el tema tiene cart drawer? buscamos su <cart-drawer> y su section id
      var drawerEl = document.querySelector('cart-drawer');
      var drawerSec = drawerEl && drawerEl.closest('[id^="shopify-section-"]');
      var drawerSectionId = drawerSec ? drawerSec.id.replace('shopify-section-', '') : null;

      var addBody = { items: items };
      if (drawerSectionId) { addBody.sections = [drawerSectionId]; }

      function resetBtn() { elAddBtn.textContent = original; elAddBtn.style.pointerEvents = ''; }

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(addBody)
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (addRes) {
          // Sin cart drawer en el tema -> vamos al carrito (fallback)
          if (!drawerSectionId) { window.location.href = data.cartRedirect || (rootUrl + 'cart'); return; }
          // Con drawer: replicamos el contrato de eventos del tema (Maestrooo) para ABRIRLO
          return fetch(rootUrl + 'cart.js')
            .then(function (c) { return c.json(); })
            .then(function (cartJson) {
              cartJson.sections = addRes.sections || cartJson.sections;
              document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  baseEvent: 'variant:add',
                  onSuccessDo: 'force_open_drawer',
                  cart: cartJson,
                  items: addRes.items || items
                }
              }));
              resetBtn();
            });
        })
        .catch(function () {
          elAddMsg.textContent = L.errorText;
          resetBtn();
        });
    }

    toggleBtns.forEach(function (b) {
      // oculta el toggle de cualquier promo sin productos conectados (ej. Promo C)
      if (!hasProducts(b.getAttribute('data-set-promo'))) { b.style.display = 'none'; b.setAttribute('hidden', 'hidden'); }
      b.addEventListener('click', function () { setPromo(b.getAttribute('data-set-promo')); });
    });
    elAddBtn.addEventListener('click', addToCart);

    // ===== Timer 24h que se reinicia cada día (hasta la fecha final) =====
    root.querySelectorAll('[data-countdown]').forEach(function (cd) {
      var finalStr = cd.getAttribute('data-final');
      var finalDl = finalStr ? new Date(finalStr).getTime() : null;
      var units = cd.querySelector('.ms-cd-units');
      var ended = cd.querySelector('.ms-cd-ended');
      var mode = cd.getAttribute('data-mode'); // 'event' = cuenta regresiva real (con días) a la fecha; si no, reinicio diario 24h
      function set(k, v) { var el = cd.querySelector('[data-cd="' + k + '"]'); if (el) el.textContent = (v < 10 ? '0' : '') + v; }
      function nextResetMs() { var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); } // próxima medianoche local
      function tick() {
        var now = Date.now();
        // se acabó la campaña completa (fecha final)
        if (finalDl && now >= finalDl) {
          set('days', 0); set('hours', 0); set('mins', 0); set('secs', 0);
          if (units) units.style.display = 'none';
          if (ended) ended.hidden = false;
          clearInterval(cd._t);
          return;
        }
        if (mode === 'event') {
          // cuenta regresiva continua a la fecha del Soltero Fest (días/hrs/min/seg)
          var d = (finalDl || now) - now;
          if (d < 0) d = 0;
          set('days', Math.floor(d / 86400000));
          set('hours', Math.floor(d % 86400000 / 3600000));
          set('mins', Math.floor(d % 3600000 / 60000));
          set('secs', Math.floor(d % 60000 / 1000));
          return;
        }
        var diff = nextResetMs() - now; // siempre < 24h -> reinicia solo al cruzar medianoche
        if (diff < 0) diff = 0;
        set('hours', Math.floor(diff / 3600000));
        set('mins', Math.floor(diff % 3600000 / 60000));
        set('secs', Math.floor(diff % 60000 / 1000));
      }
      if (cd._t) clearInterval(cd._t);
      tick();
      cd._t = setInterval(tick, 1000);
    });

    // Typewriter en el hint del buscador: cicla ejemplos de marcas que pueden escribir
    root.querySelectorAll('[data-search-demo]').forEach(function (el) {
      var words = (el.getAttribute('data-words') || 'Versace,Rasasi,One Million,Lattafa,Dylan Blue,Invictus,Hawas')
        .split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      if (!words.length) return;
      var wi = 0, ci = 0, deleting = false;
      if (el._tw) clearTimeout(el._tw);
      function step() {
        var w = words[wi % words.length];
        ci += deleting ? -1 : 1;
        el.textContent = w.slice(0, ci);
        var wait = deleting ? 45 : 95;
        if (!deleting && ci >= w.length) { deleting = true; wait = 1200; }
        else if (deleting && ci <= 0) { deleting = false; wi++; wait = 350; }
        el._tw = setTimeout(step, wait);
      }
      step();
    });

    // scroll suave para los CTA que apuntan a un ancla dentro de la sección (#builder)
    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });

    // arranca en la primera promo con productos
    setPromo(hasProducts('A') ? 'A' : (hasProducts('B') ? 'B' : 'A'));
  }

  function boot() {
    document.querySelectorAll('.mensshop-arsenal').forEach(initArsenal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // soporte para el Theme Editor (re-render al editar la sección)
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.mensshop-arsenal');
    if (root) initArsenal(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
 class LmLookBook extends HTMLElement {
  constructor() {
    super();

    this.injectVendorScripts();
    this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
      this.handleTooltip(elem);
    });
  }

  async injectVendorScripts() {
    if (!window.FloatingUICore) {
      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0');
      document.head.appendChild(script);
    }
    if (!window.FloatingUIDOM) {
      await new Promise((r) => setTimeout(r, 500));

      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1');
      document.head.appendChild(script);
    }
  }

  handleTooltip(elem) {
    const btn = elem.querySelector('button');
    const tooltip = elem.querySelector('.lm-tooltip');

    function update() {
      window.FloatingUIDOM.computePosition(btn, tooltip, {
        middleware: [
          window.FloatingUIDOM.offset(0),
          window.FloatingUIDOM.autoPlacement(),
        ],
      }).then(({ x, y }) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    }

    function showTooltip() {
      tooltip.classList.add('show');
      update();
    }

    function hideTooltip() {
      tooltip.classList.remove('show');
      tooltip.classList.add('hiding');
      setTimeout(() => {
        tooltip.classList.remove('hiding');
      }, 200);
    }

    const events = [
      ['mouseenter', showTooltip],
      ['mouseleave', hideTooltip],
      ['focus', showTooltip],
      ['blur', hideTooltip],
    ];

    // Detect if the device is touch-capable
    const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

    if (isTouchDevice) {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (tooltip.classList.contains('show')) {
          hideTooltip();
        } else {
          showTooltip();
        }
      });

      // Hide the tooltip when clicking outside
      document.addEventListener('click', (e) => {
        if (!elem.contains(e.target)) {
          hideTooltip();
        }
      });
    } else {
      events.forEach(([event, listener]) => {
        btn.addEventListener(event, listener);
      });
    }
  }
}

customElements.define('lumin-lookbook', LmLookBook);


  } catch(e) { console.error(e); }
})();
})();
